var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 36,
    viewBox: "0 0 31 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9961 9L15.4961 0L-0.00390625 9V27L15.4961 36L30.9961 27V9ZM29.2794 10.0005L15.5016 2.00049L1.72381 10.0005V26.0005L15.5016 34.0005L29.2794 26.0005V10.0005Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5506 10.9995L15.495 3.99951L3.43945 10.9995V24.9995L15.495 31.9995L27.5506 24.9995V10.9995ZM15.4979 20.1939L13.1354 21.6189L13.7541 18.9377L11.6729 17.1189L14.4104 16.8752L15.4979 14.3439L16.5854 16.8939L19.3229 17.1377L17.2416 18.9377L17.8604 21.6377L15.4979 20.1939ZM12.0854 19.4814L10.8666 24.7502L15.4979 21.9564L20.1291 24.7502L18.9104 19.4814L22.9979 15.9377L17.5979 15.4689L15.4979 10.5002L13.3979 15.4689L7.99789 15.9377L12.0854 19.4814Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.263b83cdfab33c91f56aeeb5b7f492c0.svg";
export { ForwardRef as ReactComponent };